import * as types from './types';
import { loading } from 'State/actions';
import { createToast, toastType } from 'Common/ToastHelper';
import { EditServedItemFieldEnum as Fields } from 'Common/FieldEnum';
import { DefaultPrice } from '../../helpers/EditItemHelpers';

export const getInitialData = itemId => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch({ type: types.EDIT_SERVED_ITEM_CLEAR_STATE });
    dispatch(loading(types.EDIT_SERVED_ITEM_FETCHING, true));

    try {
      let response = null;
      response = await MPWWebApi.getGeneric('grade');
      dispatch({
        type: types.EDIT_SERVED_ITEM_GET_GRADES,
        payload: response.data.Data,
      });
      if (itemId !== '0') {
        response = await MPWWebApi.getGeneric(`ServedItem/${itemId}`);
        dispatch({
          type: types.EDIT_SERVED_ITEM_GET_DATA,
          payload: response.data.Data,
        });
      } else {
        dispatch({
          type: types.EDIT_SERVED_ITEM_GET_DATA,
          payload: { Prices: [{ ...DefaultPrice }] },
        });
      }
      response = await MPWWebApi.getGeneric(`Serving/GetItemCategories`);
      dispatch({
        type: types.EDIT_SERVED_ITEM_GET_ITEM_CATEGORIES,
        payload: response.data.Data,
      });
      response = await MPWWebApi.getGeneric(`Serving/GetNutritionCodes`);
      dispatch({
        type: types.EDIT_SERVED_ITEM_GET_NUTRITION_CODES,
        payload: response.data.Data,
      });
    } catch (error) {
      dispatch({
        type: types.EDIT_SERVED_ITEM_FETCH_ERROR,
        payload: error.response.data.Data,
      });
    }

    dispatch(loading(types.EDIT_SERVED_ITEM_FETCHING, false));
  };
};

export const getAlternateItems = itemCode => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.EDIT_SERVED_ITEM_FETCHING, true));

    try {
      let response = await MPWWebApi.getGeneric(
        `ServedItem/Alternate/${itemCode}`
      );
      dispatch({
        type: types.EDIT_SERVED_ITEM_GET_ALTERNATE_ITEMS,
        payload: response.data.Data,
      });
    } catch (error) {
      dispatch({
        type: types.EDIT_SERVED_ITEM_FETCH_ERROR,
        payload: error.response.data.Data,
      });
    }

    dispatch(loading(types.EDIT_SERVED_ITEM_FETCHING, false));
  };
};

export const writeItem = itemData => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.EDIT_SERVED_ITEM_FETCHING, true));

    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        `ServedItem/Write`,
        itemData
      );
      dispatch(
        getInitialData(
          `${itemData[Fields.ItemIdLetter]}${itemData[Fields.ItemId]}`
        )
      );
      createToast(toastType.success, 'Success', 'Item saved successfully.');
      dispatch({
        type: types.EDIT_SERVED_ITEM_NEW_ID,
        payload: response.data.Data,
      });
    } catch (error) {
      dispatch({
        type: types.EDIT_SERVED_ITEM_FETCH_ERROR,
        payload: error.response.data.Data,
      });
    }

    dispatch(loading(types.EDIT_SERVED_ITEM_FETCHING, false));
  };
};

export const clearError = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch({
      type: types.EDIT_SERVED_ITEM_FETCH_ERROR,
      payload: null,
    });
  };
};



// WEBPACK FOOTER //
// ./src/pages/serveditemsetup/state/editserveditem/actions.js